import {useTranslation} from 'react-i18next'
import cssMobile from '../../../css/editorMobile.module.css'

interface ControlsBaseProps {
  children: React.ReactNode
  open: boolean
  onBackClick?: () => void
}

export default function ControlsBase({
  children,
  open,
  onBackClick,
}: ControlsBaseProps) {
  const {t} = useTranslation()

  return (
    <div className={`${cssMobile.controls} ${open ? cssMobile.open : ''}`}>
      <div className={cssMobile.controlItems}>{children}</div>
      <button
        className={`editorButton ${cssMobile.backButton}`}
        style={{marginLeft: '1rem'}}
        onClick={onBackClick}>
        {t('Kész')}
      </button>
    </div>
  )
}
